import * as yup from 'yup'
import { SYSTEM_MESSAGE_IDS } from 'src/app/shared/constants/systemMessages.constants'
import { PatternValidate } from 'src/app/shared/utils'

const phoneRegexByCountry = {
  '1': /^(\d{3}[-\s]?\d{3}[-\s]?\d{4})?$/, // USA
  '84': /^((0|\+84)\d{9,10})?$/, // Vietnam
}

function generateValidationSchema(t: any) {
  const validationSchema = yup.object().shape({
    username: yup
      .string()
      .trim()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ClientUserSetup:username.title')}`,
        }),
      ),
    firstName: yup
      .string()
      .trim()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ClientUserSetup:firstName.title')}`,
        }),
      ),
    lastName: yup
      .string()
      .trim()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ClientUserSetup:lastName.title')}`,
        }),
      ),
    emailAddress: yup
      .string()
      .trim()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ClientUserSetup:emailAddress.title')}`,
        }),
      )
      .test('emailFormat', t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_EMAIL), (value) => {
        return PatternValidate.emailPattern().test(value.toString())
      }),
    clientName: yup
      .string()
      .trim()
      .required(
        t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
          Required_Field: `${t('ClientUserSetup:clientName.title')}`,
        }),
      ),
    accountNames: yup.array().min(
      1,
      t('SystemMessages:' + SYSTEM_MESSAGE_IDS.FIELD_IS_REQUIRED, {
        Required_Field: `${t('ClientUserSetup:accountNames.title')}`,
      }),
    ),
    primaryPhoneNumber: yup.string().when('primaryPrefix', (primaryPrefix: any, schema: any) => {
      let regex: RegExp
      let prefix = primaryPrefix[0]
      switch (prefix) {
        case '1':
          regex = phoneRegexByCountry['1']
          break
        case '84':
          regex = phoneRegexByCountry['84']
          break
        default:
          regex = phoneRegexByCountry['1']
      }

      return schema.matches(regex, {
        message: t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_PHONE_NUMBER, {
          Object: t('ClientUserSetup:primaryPhoneNumber.title'),
        }),
      })
    }),
    mobileNumber: yup.string().when('mobilePrefix', (mobilePrefix: any, schema: any) => {
      let regex: RegExp
      let prefix = mobilePrefix[0]
      switch (prefix) {
        case '1':
          regex = phoneRegexByCountry['1']
          break
        case '84':
          regex = phoneRegexByCountry['84']
          break
        default:
          regex = phoneRegexByCountry['1']
      }

      return schema.matches(regex, {
        message: t('SystemMessages:' + SYSTEM_MESSAGE_IDS.INVALID_PHONE_NUMBER, {
          Object: t('ClientUserSetup:mobileNumber.title'),
        }),
      })
    }),
  })
  return validationSchema
}

export { generateValidationSchema }
